let orkaGeneration = 0

export function captureOrkaGeneration() {
  return orkaGeneration
}

export function buildOrkaVisitor(accountSettings, integrations) {
  const email = accountSettings && accountSettings.user_email
  if (!email) {
    return null
  }

  const session = {
    name: email,
    email: email,
  }
  const stores = Array.isArray(integrations) ? integrations : []
  stores.forEach((integration, index) => {
    if (integration && integration.url) {
      session[`integrations_${index}`] = integration.url
    }
  })
  if (stores[0] && stores[0].url) {
    session.current_integration = stores[0].url
  }
  return session
}

export function updateOrkaVisitor(accountSettings, integrations, seen = orkaGeneration) {
  try {
    if (seen !== orkaGeneration || !window.Orka || typeof window.Orka.update !== "function") {
      return
    }
    const session = buildOrkaVisitor(accountSettings, integrations)
    if (!session) {
      return
    }
    window.Orka.update(session)
  } catch (e) {
    console.log(e)
  }
}

export function updateOrkaCurrentIntegration(url, seen = orkaGeneration) {
  try {
    if (seen !== orkaGeneration || !url || !window.Orka || typeof window.Orka.update !== "function") {
      return
    }
    window.Orka.update({ current_integration: url })
  } catch (e) {
    console.log(e)
  }
}

export function resetOrkaSession() {
  orkaGeneration += 1
  try {
    if (window.Orka && typeof window.Orka.reset === "function") {
      window.Orka.reset()
    }
  } catch (e) {
    console.log(e)
  }
}
